import React from "react";
import "./ruko1.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import WestVillageimages from "../../../Media/Produk/West Village/Westvillage";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faArrowsUpDownLeftRight,
  faBuilding,
  faLayerGroup,
  faMedal,
  faToilet,
} from "@fortawesome/free-solid-svg-icons";

import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

const ruko1 = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const CrystalWa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20(Westfield)%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="ruko" className="container">
      <div className="containercard-ruko">
        <div className="card">
          <Slider {...settings}>
            {WestVillageimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Westfield</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Insentif Fee up to 180jt</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#00234B" icon={faArrowsUpDownLeftRight} />
            <span> 105m²</span>
            <FontAwesomeIcon color="#00234B" icon={faBuilding} />
            <span> 487m²</span>
            <FontAwesomeIcon color="#00234B" icon={faLayerGroup} />
            <span> 3</span>
            <FontAwesomeIcon color="#00234B" icon={faToilet} />
            <span> 3</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">11 Juta/</div>
              <div className="ket">Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button onClick={CrystalWa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default ruko1;
